import Button from 'common/vue/PrimeVueConfig/Button';
import Menubar from 'common/vue/PrimeVueConfig/Menubar';
import Avatar from 'common/vue/PrimeVueConfig/Avatar';
import Badge from 'common/vue/PrimeVueConfig/Badge';
import Carousel from 'common/vue/PrimeVueConfig/Carousel';
import Tooltip from 'common/vue/PrimeVueConfig/Tooltip';
import Paginator from 'common/vue/PrimeVueConfig/Paginator';
import Message from 'common/vue/PrimeVueConfig/Message';
import SpeedDial from 'common/vue/PrimeVueConfig/SpeedDial';
import Popover from 'common/vue/PrimeVueConfig/Popover';
import Select from 'common/vue/PrimeVueConfig/Select';
import MultiSelect from 'common/vue/PrimeVueConfig/MultiSelect';
import FloatLabel from 'common/vue/PrimeVueConfig/FloatLabel';
import InputText from 'common/vue/PrimeVueConfig/InputText';
import Textarea from 'common/vue/PrimeVueConfig/Textarea';
import Listbox from 'common/vue/PrimeVueConfig/Listbox';
import FileUpload from 'common/vue/PrimeVueConfig/FileUpload';
import Editor from 'common/vue/PrimeVueConfig/Editor';
import Panel from 'cInterface/PrimeVueConfig/Panel'; // Custom Panel config for clientInterface
import Breadcrumb from 'common/vue/PrimeVueConfig/Breadcrumb';
import DatePicker from 'common/vue/PrimeVueConfig/DatePicker';
import Slider from 'common/vue/PrimeVueConfig/Slider';
import Toast from 'common/vue/PrimeVueConfig/Toast';
import Dialog from 'common/vue/PrimeVueConfig/Dialog';
import ConfirmDialog from 'common/vue/PrimeVueConfig/ConfirmDialog';
import ProgressBar from 'common/vue/PrimeVueConfig/ProgressBar';
import Checkbox from 'common/vue/PrimeVueConfig/Checkbox';
import InputGroup from 'common/vue/PrimeVueConfig/InputGroup';
import InputGroupAddon from 'common/vue/PrimeVueConfig/InputGroupAddon';
import RadioButton from 'common/vue/PrimeVueConfig/RadioButton';
import Tag from 'common/vue/PrimeVueConfig/Tag';
import SelectButton from 'common/vue/PrimeVueConfig/SelectButton';
import ToggleSwitch from 'common/vue/PrimeVueConfig/ToggleSwitch';
export default {
    button: Button,
    menubar: Menubar,
    avatar: Avatar,
    badge: Badge,
    carousel: Carousel,
    paginator: Paginator,
    Message: Message,
    SpeedDial: SpeedDial,
    Popover: Popover,
    Select: Select,
    MultiSelect: MultiSelect,
    FloatLabel: FloatLabel,
    InputText: InputText,
    Textarea: Textarea,
    Listbox: Listbox,
    FileUpload: FileUpload,
    Editor: Editor,
    Panel: Panel,
    Breadcrumb: Breadcrumb,
    DatePicker: DatePicker,
    Slider: Slider,
    Toast: Toast,
    Dialog: Dialog,
    ConfirmDialog: ConfirmDialog,
    ProgressBar: ProgressBar,
    Checkbox: Checkbox,
    InputGroup: InputGroup,
    InputGroupAddon: InputGroupAddon,
    RadioButton: RadioButton,
    Tag: Tag,
    SelectButton: SelectButton,
    ToggleSwitch: ToggleSwitch,
    directives: {
        tooltip: Tooltip,
    },
};
